export default __webpack_public_path__ + "static/media/spc_mark.0ad3b593.jpg";